<script>
    import {store} from "../store";

    export default {
        data() {
            return {
                store: store
            }
        },
        methods: {
            label(item){
                return item.name;
            },
            onSelectNode(item) {
                this.store.mutations.setSelectNode(item);
            }
        },
        computed: {
            getBreadcrumbs() {
                return this.store.getters.breadcrumbs();
            }
        },
    }
</script>
<template>
    <div class="cluster-breadcrumbs">
        <ol v-if="getBreadcrumbs.length > 0">
            <li v-for="item in getBreadcrumbs">
                <span v-if="item.keys_count === 0" :title="label(item)">{{label(item)}}</span>
                <a v-if="item.keys_count > 0" @click.prevent="onSelectNode(item)" :title="label(item)">{{label(item)}}</a>
            </li>
        </ol>
    </div>
</template>

<style scoped>
    .cluster-breadcrumbs {
        font-size: 13px;
        margin: 0 0 5px;
    }

    .cluster-breadcrumbs ol {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        overflow: auto;
    }
    .cluster-breadcrumbs li {
        display: flex;
    }
    .cluster-breadcrumbs span,
    .cluster-breadcrumbs a {
        display: inline-block;
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .cluster-breadcrumbs a {
        text-decoration: none;
        cursor: pointer;
    }

    .cluster-breadcrumbs li:not(:last-child):after {
        content: "›\00a0";
        display: inline-block;
        padding-left: .75ch;
        speak: none;
    }

    .cluster-breadcrumbs [aria-current="page"] {
        color: inherit;
        font-weight: normal;
        text-decoration: none;
    }

    .cluster-breadcrumbs [aria-current="page"]:hover,
    .cluster-breadcrumbs [aria-current="page"]:focus {
        text-decoration: underline;
    }

</style>
